// extracted by mini-css-extract-plugin
module.exports = {"root":"SidebarTooltip_root__ig9V-","text":"SidebarTooltip_text__2fPEk"};